import axios from "axios";
import commonActions from "../../common.actions";
import getApiUrl from "../../helpers/api-urls";
import { getApiUniqueRequestId } from "../../helpers/util-common";
import { updateBallotStatus } from "./openAPI";
import { BallotFolderStatus, VOTE_TYPE_ID } from "../../../common.enum";
import { SET_VOTE_DETAIL, VOTE_DETAIL } from "../../action-type";

export const getDate: any = (dispatch: any, callback: any): void => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "getDate");
  axios
    .get(url)
    .then((response: any) => {
      dispatch(commonActions.setLoader(false));
      if (response && response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      callback({});
    });
};

export const publishBallotAction = (payload: any, dispatch: any, callback: any): void => {
    dispatch(commonActions.setLoader(true));
    const url = getApiUrl("ballots", "publishBallot");
    axios
        .post(url, payload)
        .then((response: any) => {
            dispatch(commonActions.setLoader(false));
            if (response && response.data.status) {
                const openURLPayload: {BallotFolderName: string, Status: string, CloseDate?: string | Date,
                  ActualBallotStatus?: string
                } = {
                  BallotFolderName: payload.BallotFolder,
                  Status: BallotFolderStatus[payload.BallotStatusId],
                  ActualBallotStatus: BallotFolderStatus[payload.BallotStatusId]
                }
                if (payload.ClosingDate) {
                  openURLPayload.CloseDate = payload.ClosingDate
                }
                updateBallotStatus([openURLPayload], dispatch, (openAPIResponse) => {
                  if (openAPIResponse.message) {
                    callback({status: response.data.status });
                  } else {    
                    const uniqueRequestId = getApiUniqueRequestId(url);
                    callback({});
                    dispatch(commonActions.setMessage(true, "3003", uniqueRequestId));
                  }
                })
            } else {
                const uniqueRequestId = getApiUniqueRequestId(url);
                callback({});
                dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false));
            callback({});
            const uniqueRequestId = getApiUniqueRequestId(url);
            dispatch(commonActions.setMessage(true, "3003", uniqueRequestId));
        });
};

export const voterListAction: any = (ballotId: string, Committee : string, committeeLevels : string, dispatch: any, callback: any): void => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "voterListAction");
  let data = {
    PageNumber: 1,
    PageSize: -1,
    SortColumnWithOrder: {
      AccountNumber: 1,
    },
    BallotId: ballotId,
    Committee: Committee,
    committeeLevels: committeeLevels,
  };
  axios
    .post(url, data)
    .then((response: any) => {
      dispatch(commonActions.setLoader(false));
      if (response && response.data.status) {
        callback({ content: response.data.content, status: response.data.status });
      } else {
        const uniqueRequestId = getApiUniqueRequestId(url);
        callback({});
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      callback({});
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "3003", uniqueRequestId));
    });
};

// Get vote detail
export const getVoteDetail = (data: Record<string, string>, dispatch: any, callback: Function) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "voteDetail");
  const queryString = new URLSearchParams(data).toString();
  const apiUrl = `${url}?${queryString}`;
  axios
    .get(apiUrl)
    .then((response: any) => {
      dispatch(commonActions.setLoader(false));
      if (response?.data?.status) {
        dispatch({
          type: VOTE_DETAIL,
          data: response.data.content,
        });
        const updatedData = {
        ...response.data.content, 
          BallotVoteItems: response.data.content.BallotVoteItems.map((i) => {
            if (i.IsItemRemoved) {
              return {
                ...i,
                VoteTypeId: VOTE_TYPE_ID.ABSTAIN,
                Error: false,
              };
            }
            return i;
          }),
        };
        dispatch({
          type: SET_VOTE_DETAIL,
          data: updatedData,
        });
        callback(response);
      } else {
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        callback({});
      }
    })
    .catch(() => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "3003", uniqueRequestId));
      callback({});
    });
}

export const getAllMemberListAction = (dispatch: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("member", "getAllMembers");
  axios
    .get(url)
    .then((response: any) => {
      dispatch(commonActions.setLoader(false));
      if (response && response.data.status) {
        callback(response.data.content);
      } else {
        const uniqueRequestId = getApiUniqueRequestId(url);
        callback({});
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      callback({});
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "3003", uniqueRequestId));
    });
};

export const submitBallotVoteAction = async (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "submitBallotVote");
  axios
    .post(url, data)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

export const updateBallotVoteAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "updateBallotVote");
  axios
    .put(url, data)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

export const removeBallotItemAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballotItem", "removeBallotItem");
  axios
    .delete(url+`?payload=${JSON.stringify(data)}`)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

export const getDocumentInfoAction: any = (param: string, dispatch: any, callback: Function) => {
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let oktaToken = oktaResponse;
    dispatch(commonActions.setLoader(true));
    let url = `${getApiUrl("openAPI", "getDocumentInfo", true)}/${param}`;
    oktaToken["keep-body-params"] = "false";
    axios
      .get(url,{
        headers: { ...oktaToken },
      })
      .then((response: any) => {
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.data.Status) {
         callback(response.data.Result.Data);
        }else{
          callback([])
        }
      })
      .catch((err) => {
        dispatch(commonActions.setLoader(false));
      });
  })
}
export const updateRepublishAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  commonActions.ValidateOktaToken((oktaResponse: any) => {
  let oktaToken = oktaResponse;
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("openAPI", "updateRepublish",true);
  oktaToken["keep-body-params"] = "false";
  axios
    .put(url, data,{
        headers: { ...oktaToken },
      })
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.Status) {
        callback(response);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
  })
};
export const getBallotfolderStatusAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let oktaToken = oktaResponse;
    dispatch(commonActions.setLoader(true));
    let url = `${getApiUrl("openAPI", "getBallotfolderStatus", true)}`;
    oktaToken["keep-body-params"] = "false";
    axios
      .post(url,data,{
        headers: { ...oktaToken },
      })
      .then((response) => {
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.data.Status) {
          callback(response.data.Result);
        } else {
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
          callback({});
        }
      })
      .catch((err) => {
        dispatch(commonActions.setLoader(false));
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
      });
  })
};

export const getBallotAuditLogsAction = (data, dispatch, callback) => {
  const url = getApiUrl('ballots', 'ballotAuditLogs'); 
  dispatch(commonActions.setLoader(true));
  axios.get(url, { params: { requestData:JSON.stringify(data) } })
     .then((response) => {
      dispatch(commonActions.setLoader(false));

        if (response.data.status) {
           callback(response.data.content);
        } else {
           // Handle error case
           dispatch(commonActions.setMessage(true, response.data.message));
           callback(false);
        }
     })
     .catch((err) => {
        callback(false);
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, '3000'));
     });
}
